import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { useContext, useEffect } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import { useStores } from 'stores';
import { AuthContext } from 'context';
import {
  ADMIN_PAGE,
  MY_CHARITY_BANNERS_PAGE,
  MY_LOTS_PAGE,
  MY_SUBSCRIPTIONS_PAGE,
  NEW_SUBSCRIPTION_PAGE,
  REDIRECT_AFTER_LOGIN_KEY
} from '../constants';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';
// New refactored header with UI kit usage, styles not yet applied.
// After theme is ready this header will be used here.
// import Header from './components/Header/Header';
import Admin from '../pages/Admin';
import Conversations from '../pages/Conversations';
import Favorites from '../pages/Favorites';
import Home from '../pages/Home';
import ViewLot from '../pages/Lot/View';
import AddLot from '../pages/Lot/Add';
import EditLot from '../pages/Lot/Edit';
import MyLots from '../pages/MyLots';
import NotFound from '../pages/NotFound';
import PreLogin from '../pages/PreLogin';
import Profile from '../pages/Profile';
import MySubscriptions from '../pages/MySubscriptions';
import Subscription from '../pages/Subscription';
import MyCharityBanners from 'pages/MyCharityBanners';

const PostLoginRedirect = ({ isAuthenticated }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) return;
    const redirect = sessionStorage.getItem(REDIRECT_AFTER_LOGIN_KEY);
    if (!redirect) return;

    sessionStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
    const currentPath = window.location.pathname + window.location.search;
    if (redirect !== currentPath) {
      navigate(redirect, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return null;
};

PostLoginRedirect.propTypes = {
  isAuthenticated: PropTypes.bool,
};

const Router = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const {
    singleLotStore: { lotCategories },
    userStore: { isAdmin },
  } = useStores();

  const categoryPathes = lotCategories.map(({ link }) => `/${link}`);

  useEffect(() => {
    if (isAuthenticated === false) {
      const path = window.location.pathname + window.location.search;
      if (path !== '/') {
        sessionStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, path);
      }
    }
  }, [isAuthenticated]);

  // TODO: hardcoded isAdmin to true for now for admin page, will be set based on token data in the future
  return (
    <BrowserRouter>
      <PostLoginRedirect isAuthenticated={isAuthenticated} />
      {!isAuthenticated && (
        <Routes>
          <Route path="/" element={<PreLogin />} />
          <Route path="*" element={<PreLogin />} />
        </Routes>
      )}
      {isAuthenticated && (
        <>
          <Header />
          <Routes>
            <Route path="/" element={<Home title="All Lots" />} />
            {categoryPathes.map(path => (
              <Route key={path} path={path} element={<Home title="All Lots" />} />
            ))}
            <Route path="/charityList" element={<Home title="Charity" />} />
            <Route path="/lot/:id" element={<ViewLot />} />
            {true && <Route path={ADMIN_PAGE.href} element={<Admin />} />}
            <Route path="/favorites" element={<Favorites />} />
            <Route path={MY_LOTS_PAGE.href} element={<MyLots />} />
            <Route path={MY_CHARITY_BANNERS_PAGE.href} element={<MyCharityBanners title="My Charity Banners" />} />
            <Route
              path={MY_SUBSCRIPTIONS_PAGE.href}
              element={<MySubscriptions title={MY_SUBSCRIPTIONS_PAGE.title} />}
            />
            <Route path={NEW_SUBSCRIPTION_PAGE.href} element={<Subscription title={NEW_SUBSCRIPTION_PAGE.title} />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/create" element={<AddLot />} />
            <Route path="/charity" element={<AddLot step={1} />} />
            <Route path="/edit/:id" element={<EditLot />} />
            <Route path="/conversations" element={<Conversations />} />
            <Route path="/conversation/:id" element={<Conversations />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </>
      )}
    </BrowserRouter>
  );
};

export default observer(Router);
